import { createAction } from '@reduxjs/toolkit';
import type { PopulatedUser } from '@/services/api/users';
import { CHANGE_USER_SETTINGS_ERROR, CHANGE_USER_SETTINGS_SUCCESS } from './constants';

export const changeUserSettingsSuccess = createAction<PopulatedUser>(CHANGE_USER_SETTINGS_SUCCESS);
export const changeUserSettingsError = createAction<unknown>(CHANGE_USER_SETTINGS_ERROR);
